import React from "react";
import { VideoJS } from "./videojs";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";
import RecordingTimelineEnhancements from "./recording-timeline-enhancements";
import type { InteractionLog } from "../utils/types";

const RecordingVideoPlayer = ({
  videoUrl,
  interactionLogs = [],
  startedTimeInEpoch,
  finishedTimeInEpoch,
}: {
  videoUrl?: string;
  interactionLogs?: InteractionLog[];
  startedTimeInEpoch?: number;
  finishedTimeInEpoch?: number;
}) => {
  const videoJsOptions = {
    controls: true,
    responsive: true,
    fill: true,
    sources: [
      {
        src: videoUrl,
        type: "video/mp4",
      },
    ],
  };

  if (videoUrl == null) {
    return <Typography>Video Recording will be available shortly</Typography>;
  }

  return (
    <PlayerContainer>
      <VideoJS options={videoJsOptions} />
      <RecordingTimelineEnhancements
        interactionLogs={interactionLogs}
        startedTimeInEpoch={startedTimeInEpoch}
        finishedTimeInEpoch={finishedTimeInEpoch}
      />
    </PlayerContainer>
  );
};

const PlayerContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export default RecordingVideoPlayer;
